<template>
  <div :class="['axiome-logique-container', 'axiome-logique-has-value']">
    <!--Affichage OnProperty-->
    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="onPropertyLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge" />
      <template v-if="blankNodes.length">
        <AttributeBlankNode :blankNodes="blankNodes" :leftMargin="false" :showLanguageBadge="showLanguageBadge"
          :showFirstOperand="onPropertyLiterals !== undefined && onPropertyLiterals.length > 0" />
      </template>
    </div>
    <!--Affichage Operand-->
    <span
      :class="['axiome-logique-operand', ' ml-2', ' mr-2', { 'axiome-logique-operand-level0': level0 }]">value</span>

    <!--Affichage values-->
    <PropertyValue :values="hasValueLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge" />
  </div>

</template>

<script>
export default {
  name: "LogicalAxiomeHasValue",
  computed: {
    hasValueLiterals() {
      let result = [];
      this.hasValue.forEach(element => {
        result.push(...element.literals);
      });
      return result;
    }
  },
  props: {
    level0: {
      type: Boolean,
      default: false
    },
    onProperty: {
      type: Array,
      default: () => []
    },
    hasValue: {
      type: Array,
      default: () => []
    },
    blankNodes: {
      type: Array,
      default: () => []
    },
    onPropertyLiterals: {
      type: Array,
      default: () => []
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    }
  }
}
</script>
